import styled from 'styled-components';

export const MapWrapper = styled.div`
  margin-top: 20px;
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`;
